function getQuestionPool(topic) {
  if (topic === "bigNumbers") {
    return [
      // 1) Rounding large numbers
      {
        question: () => {
          const n = Math.floor(Math.random() * 90000) + 10000; // 10000..99999
          const roundTo = [1000, 10000][Math.floor(Math.random() * 2)];
          const rounded = Math.round(n / roundTo) * roundTo;
          return {
            q: `Round ${n} to the nearest ${roundTo}:`,
            a: String(rounded),
            distract: [String(rounded + roundTo), String(rounded - roundTo)]
          };
        },
      },
      // 2) Multi-digit multiplication
      {
        question: () => {
          const a = Math.floor(Math.random() * 900) + 100;  // 100..999
          const b = Math.floor(Math.random() * 90) + 10;    // 10..99
          const prod = a * b;
          return {
            q: `What is ${a} × ${b}?`,
            a: String(prod),
            distract: [String(prod + 50), String(Math.max(1, prod - 50))]
          };
        },
      },
      // 3) Long division
      {
        question: () => {
          const divisor = Math.floor(Math.random() * 90) + 10; 
          const quotient = Math.floor(Math.random() * 90) + 10;
          const remainder = Math.floor(Math.random() * divisor);
          const dividend = divisor * quotient + remainder;
          return {
            q: `Divide ${dividend} ÷ ${divisor}. (Give quotient & remainder)`,
            a: `Q=${quotient}, R=${remainder}`,
            distract: [
              `Q=${quotient+1}, R=${remainder}`,
              `Q=${quotient}, R=${remainder+1}`
            ]
          };
        }
      },
      // 4) Compare two 5-digit numbers
      {
        question: () => {
          const x = Math.floor(Math.random()*90000)+10000;
          const y = Math.floor(Math.random()*90000)+10000;
          if (x === y) {
            return {
              q: `Which is bigger: ${x} or ${y}?`,
              a: "They are equal",
              distract: []
            };
          } else {
            const bigger = x>y ? x : y;
            const smaller= x>y ? y : x;
            return {
              q: `Which is bigger: ${x} or ${y}?`,
              a: String(bigger),
              distract: [String(smaller)]
            };
          }
        }
      },
    ];
  } else if (topic === "fractions") {
    return [
      // 1) fraction addition => decimal
      {
        question: () => {
          const a1 = Math.floor(Math.random() * 5) + 1;
          const d1 = Math.floor(Math.random() * 5) + 2;
          const a2 = Math.floor(Math.random() * 5) + 1;
          const d2 = Math.floor(Math.random() * 5) + 2;
          const sum = (a1/d1)+(a2/d2);
          return {
            q: `Add the fractions: ${a1}/${d1} + ${a2}/${d2} = ? (decimal)`,
            a: sum.toFixed(2),
            distract: [
              (sum+0.25).toFixed(2),
              Math.max(0,sum-0.25).toFixed(2)
            ]
          };
        }
      },
      // 2) fraction multiplication => decimal
      {
        question: () => {
          const n1 = Math.floor(Math.random()*5)+1;
          const d1 = Math.floor(Math.random()*5)+2;
          const n2 = Math.floor(Math.random()*5)+1;
          const d2 = Math.floor(Math.random()*5)+2;
          const product = (n1/d1)*(n2/d2);
          return {
            q: `Multiply: ${n1}/${d1} × ${n2}/${d2} = ? (decimal)`,
            a: product.toFixed(2),
            distract: [
              (product+0.5).toFixed(2),
              Math.max(0,product-0.5).toFixed(2)
            ]
          };
        }
      },
      // 3) fraction division => decimal
      {
        question: () => {
          const numerator = Math.floor(Math.random()*4)+1;
          const denom = Math.floor(Math.random()*4)+2;
          const divisor = Math.floor(Math.random()*3)+1;
          const fractionVal = numerator/denom;
          const result = fractionVal/divisor;
          return {
            q: `Divide: ${numerator}/${denom} ÷ ${divisor} = ? (decimal)`,
            a: result.toFixed(2),
            distract: [
              (result+0.5).toFixed(2),
              Math.max(0,result-0.5).toFixed(2)
            ]
          };
        },
      },
      // 4) fraction * whole number
      {
        question: () => {
          const whole = Math.floor(Math.random()*5)+2;
          const num = Math.floor(Math.random()*4)+1;
          const den = Math.floor(Math.random()*4)+2;
          const val = whole*(num/den);
          return {
            q: `What is ${whole} × ${num}/${den}? (decimal)`,
            a: val.toFixed(2),
            distract: [
              (val+1).toFixed(2),
              Math.max(0,val-1).toFixed(2)
            ]
          };
        }
      },
    ];
  } else if (topic === "decimalsPercent") {
    return [
      // 1) X% of Y
      {
        question: () => {
          const perc = Math.floor(Math.random()*21)+10;
          const val  = Math.floor(Math.random()*20)+1;
          const ans  = (perc/100)*val;
          return {
            q: `What is ${perc}% of ${val}?`,
            a: ans.toFixed(2),
            distract: [
              (ans+0.5).toFixed(2),
              Math.max(0,ans-0.5).toFixed(2)
            ]
          };
        }
      },
      // 2) decimal => fraction approximate
      // 2) decimal => fraction approximate
{
  question: () => {
    const dec = ((Math.floor(Math.random() * 70) + 10) / 100).toFixed(2); // 0.10 to 0.79
    const fracSet = [
      "1/4=0.25", "1/3=0.33", "1/2=0.5", "2/3=0.67", "3/4=0.75", "4/5=0.80", "3/5=0.60"
    ];

    let best = null;
    for (let f of fracSet) {
      const [numDen, valStr] = f.split("=");
      const diff = Math.abs(parseFloat(dec) - parseFloat(valStr));
      if (!best || diff < best.diff) {
        best = { fraction: numDen, diff };
      }
    }

    return {
      q: `Decimal to fraction: ${dec}\nWhich fraction is closest?`,
      a: best.fraction,
      distract: fracSet
        .map(f => f.split("=")[0])
        .filter(x => x !== best.fraction)
        .sort(() => 0.5 - Math.random())
        .slice(0, 2)
    };
  }
},
      // 3) small decimal addition
      {
        question: () => {
          const d1 = ((Math.floor(Math.random()*90)+10)/100).toFixed(2);
          const d2 = ((Math.floor(Math.random()*90)+10)/100).toFixed(2);
          const sum = (parseFloat(d1)+parseFloat(d2)).toFixed(2);
          return {
            q: `Add the decimals: ${d1} + ${d2} = ?`,
            a: sum,
            distract: [
              (parseFloat(sum)+0.5).toFixed(2),
              (parseFloat(sum)-0.5).toFixed(2)
            ]
          };
        }
      }
    ];
  } else if (topic === "measurementVolume") {
    return [
      // 1) Volume
      {
        question: () => {
          const length = Math.floor(Math.random()*5)+2;
          const width  = Math.floor(Math.random()*5)+2;
          const height = Math.floor(Math.random()*5)+2;
          const vol = length*width*height;
          return {
            q: `Volume of a ${length}cm×${width}cm×${height}cm box = ? (cm³)`,
            a: String(vol),
            distract: [String(vol+5), String(length+width+height)]
          };
        }
      },
      // 2) Convert length
      {
        question: () => {
          const meters = (Math.floor(Math.random()*9)+1)*1000; // 1000..9000
          const km = meters/1000;
          return {
            q: `Convert ${meters} m to km:`,
            a: String(km),
            distract: [String(km+1), String((km/2).toFixed(1))]
          };
        }
      },
      // 3) Perimeter of rectangle
      {
        question: () => {
          const a = Math.floor(Math.random()*10)+3;
          const b = Math.floor(Math.random()*10)+3;
          const peri = 2*(a+b);
          return {
            q: `A rectangle is ${a}m × ${b}m. What's the perimeter in m?`,
            a: String(peri),
            distract: [String(peri+2), String(a*b)]
          };
        }
      }
    ];
  } else if (topic === "coordinateData") {
    return [
      // 1) Quadrant
      {
        question: () => {
          let xx, yy;
          do { xx=Math.floor(Math.random()*11)-5;} while(xx===0);
          do { yy=Math.floor(Math.random()*11)-5;} while(yy===0);
          let quadrant;
          if(xx>0&&yy>0) quadrant="Quadrant I";
          else if(xx<0&&yy>0) quadrant="Quadrant II";
          else if(xx<0&&yy<0) quadrant="Quadrant III";
          else quadrant="Quadrant IV";
          return {
            q:`Which quadrant is (${xx},${yy}) in?`,
            a: quadrant,
            distract:["Quadrant I","Quadrant II","Quadrant III","Quadrant IV"].filter(x=>x!== quadrant)
          };
        }
      },
      // 2) data bar question
      {
        question: () => {
          const itemA = Math.floor(Math.random()*10)+1;
          const itemB = Math.floor(Math.random()*10)+1;
          if (itemA===itemB){
            return {
              q:`Apples(${itemA}) vs Bananas(${itemB}). Which is larger?`,
              a:"Equal",
              distract:["Apples","Bananas"]
            };
          } else {
            const correct = itemA>itemB?"Apples":"Bananas";
            const wrong   = itemA>itemB?"Bananas":"Apples";
            return {
              q:`Apples(${itemA}) vs Bananas(${itemB}). Which is larger?`,
              a: correct,
              distract:[wrong]
            };
          }
        }
      },
      // 3) geometry angle question
      {
        question: () => {
          const angleSet = [
            ["Right angle","90°","45°","180°"],
            ["Straight line angle","180°","90°","360°"],
            ["Full circle","360°","180°","270°"],
          ];
          const pick = angleSet[Math.floor(Math.random()*angleSet.length)];
          return {
            q:`How many degrees is a ${pick[0]}?`,
            a: pick[1],
            distract:[pick[2], pick[3]]
          };
        }
      },
    ];
  } else {
    // summaryReview
    const summaryPool = [
      {
        q: "Quick check: 12 × 3 = ?",
        a: "36",
        distract: ["33","39"]
      },
      {
        q: "Round 984 to the nearest 10:",
        a: "980",
        distract: ["990","984"]
      },
      {
        q: "What is 25% of 40?",
        a: "10",
        distract: ["8","12"]
      },
      {
        q: "Convert 2500 m to km:",
        a: "2.5",
        distract: ["25","1.25"]
      },
      {
        q: "Which fraction is bigger, 3/8 or 1/4?",
        a: "3/8",
        distract: ["1/4"]
      },
      {
        q: "Add decimals: 0.25 + 0.45 = ?",
        a: "0.70",
        distract: ["0.60","0.75"]
      },
      {
        q: "Volume of 2cm × 3cm × 4cm box = ? (cm³)",
        a: "24",
        distract: ["9","14"]
      },
    ];
    const picked = summaryPool[Math.floor(Math.random()*summaryPool.length)];
    const allOpts = [picked.a, ...picked.distract].sort(()=>Math.random()-0.5);
    return {
      question: picked.q,
      correctAnswer: picked.a,
      options: allOpts
    };
  }
}

/* ------------------------------------------------------------------
   4) QUIZ QUESTION GENERATION
   - Each topic has a pool. 
   - The "summaryReview" category has multiple random possibilities 
     instead of repeating "12×3" forever.
------------------------------------------------------------------ */
export function generateQuizQuestion(forcedTopic) {
  const topics = forcedTopic
    ? [forcedTopic]
    : ["bigNumbers", "fractions", "decimalsPercent", "measurementVolume", "coordinateData", "summaryReview"];

  const topic = topics[Math.floor(Math.random() * topics.length)];
  const subPool = getQuestionPool(topic);

  if (!Array.isArray(subPool) || subPool.length === 0) {
    console.error(`❌ Error: No valid subPool for topic: ${topic}`);
    return null;
  }

  const chosen = subPool[Math.floor(Math.random() * subPool.length)];
  if (!chosen || typeof chosen.question !== "function") {
    console.error(`❌ Error: Chosen item has no .question() in topic: ${topic}`);
    return null;
  }

  const qObj = chosen.question();
  if (!qObj || !qObj.q || !qObj.a) {
    console.error(`❌ Malformed question object in topic: ${topic}`, qObj);
    return null;
  }

  const question = qObj.q;
  const correctAnswer = qObj.a;
  const allOptions = [correctAnswer, ...(qObj.distract || [])].sort(() => Math.random() - 0.5);

  return {
    question,
    correctAnswer,
    options: allOptions
  };
}
